export default __webpack_public_path__ + "static/media/thumb-Marine-Receiver-4.b6470a53.png";